import React, { useContext } from "react";
import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ptLocale from "date-fns/locale/pt";
import enLocale from "date-fns/locale/en-US";

import { LanguageContext } from "../languageProvider";

const LOCALE_MAP = {
  en: enLocale,
  pt: ptLocale,
};

const DatePickerHolder = ({ elements }) => {
  const { lang } = useContext(LanguageContext);
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={LOCALE_MAP[lang]}>
      <>
        {elements.type === "date" && (
          <DatePicker
            {...elements}
            maxDate={elements.maxDate ? elements.maxDate : new Date()}
            InputProps={{ disableUnderline: true }}
            views={["year", "month", "date"]}
            format={elements.format ? elements.format : "yyyy-MM-dd"}
            onChange={elements.onChange && elements.onChange}
          />
        )}

        {elements.type === "time" && (
          <TimePicker
            disabled={elements.disabled && elements.disabled}
            ampm={false}
            InputProps={{ disableUnderline: true }}
            value={elements.value && elements.value}
            onChange={elements.onChange && elements.onChange}
          />
        )}
      </>
    </MuiPickersUtilsProvider>
  );
};

export default DatePickerHolder;
